// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602271008/js/" + chunkId + "." + {"44":"1429dec9","225":"73079c96","481":"9f1921d2","486":"b12abc5b","770":"277b9c0c"}[chunkId] + ".0.010467341778953143.chunk.js";
};